
// Range Slider - https://www.cssscript.com/custom-range-slider-input/

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.rangeSlider=t():e.rangeSlider=t()}(this,(()=>{return e={265:function(e){e.exports=(e,t={})=>{const a=e=>!isNaN(e)&&+e+""==e+"",n=(e=0,t=0)=>({min:e,max:t}),i=e=>{[M,F].forEach(e)},r=(e,t,a)=>{if(e)return t;a()},s=(e,t,a="")=>{e.setAttribute(t,a)},l=(e,t)=>{e.removeAttribute(t)},m=(e,t,a,n=!0)=>{e.addEventListener(t,a,n?{passive:!1,capture:!0}:{})},d=(e,t,a,n=!0)=>{e.removeEventListener(t,a,n?{passive:!1,capture:!0}:{})},o=(e,a)=>{t[e]={}.hasOwnProperty.call(t,e)?t[e]:a},u=(e,a)=>t.orientation===H?e:a,b=e=>1===e?Q.max:Q.min,h=()=>{let e=!1;a(t.min)&&a(t.max)||(e=!0),t.min=e?1:+t.min,t.max=e?1:+t.max},p=()=>{t.thumbsDisabled instanceof Array?(1===t.thumbsDisabled.length&&t.thumbsDisabled.push(!1),1!==t.thumbsDisabled.length&&2!==t.thumbsDisabled.length&&(t.thumbsDisabled=[!1,!1])):t.thumbsDisabled=[t.thumbsDisabled,t.thumbsDisabled],t.thumbsDisabled[0]=!!t.thumbsDisabled[0],t.thumbsDisabled[1]=!!t.thumbsDisabled[1]},g=(e,a=!1,i=!0,r=!0)=>{const m=n(le[Q.min].value,le[Q.max].value);e=e||m,le[Q.min].value=e.min,le[Q.max].value=ie||a?e.max:e.min+ae,c(),K.min>K.max&&(Q.min=+!Q.min,Q.max=+!Q.max,l(me[Q.min],V),l(me[Q.max],P),s(me[Q.min],P),s(me[Q.max],V),ie&&(ie=ie===M?F:M),c()),ee=a?K:e;let d=!1;(m.min!==le[Q.min].value||a)&&(d=!0),(m.max!==le[Q.max].value||a)&&(d=!0),d&&(i&&t.onInput&&t.onInput([K.min,K.max],r),$(),x(),f(),w())},c=()=>{i((e=>{K[e]=+le[Q[e]].value}))},x=()=>{i((e=>{me[Q[e]].style[u("top","left")]=`calc(${(K[e]-t.min)/te*100}% + ${(.5-(K[e]-t.min)/te)*u(W,U)[e]}px)`}))},f=()=>{const a=e.getBoundingClientRect(),n=(.5-(K.min-t.min)/te)*u(W,U).min/u(a.bottom-a.top,a.right-a.left),i=(.5-(K.max-t.min)/te)*u(W,U).max/u(a.bottom-a.top,a.right-a.left);se.style[u("top","left")]=100*((K.min-t.min)/te+n)+"%",se.style[u("height","width")]=100*((K.max-t.min)/te-(K.min-t.min)/te-n+i)+"%"},v=()=>{i(((e,a)=>{Z[e]=t.thumbsDisabled[a]?K[e]:t[e]}))},D=()=>{i(((e,a)=>{t.disabled||t.thumbsDisabled[a]?l(me[b(a)],O):s(me[b(a)],O,0)}))},w=()=>{i((e=>{s(me[Q[e]],"aria-valuemin",t.min),s(me[Q[e]],"aria-valuemax",t.max),s(me[Q[e]],"aria-valuenow",K[e]),s(me[Q[e]],"aria-valuetext",K[e])}))},y=()=>{t.disabled?s(e,J):l(e,J)},_=()=>{t.thumbsDisabled.forEach(((e,t)=>{const a=b(t);e?(s(me[a],J),s(me[a],"aria-disabled",!0)):(l(me[a],J),s(me[a],"aria-disabled",!1))}))},S=(e,a=!1)=>{t[e]=a,h(),i((e=>{le[0][e]=t[e],le[1][e]=t[e]})),te=t.max-t.min,g("",!0,!0,!1),v()},E=()=>{t.orientation===H?s(e,Y):l(e,Y),se.style[u("left","top")]="",se.style[u("width","height")]="",me[0].style[u("left","top")]="",me[1].style[u("left","top")]=""},$=()=>{i((e=>{U[e]=q(N(me[Q[e]]).width),W[e]=q(N(me[Q[e]]).height)}))},k=(a,n)=>{const i=e.getBoundingClientRect(),r=n.getBoundingClientRect(),s=(u(r.top-i.top,r.left-i.left)+(a[`client${u("Y","X")}`]-n.getBoundingClientRect()[u("top","left")])-(ie?(.5-(K[ie]-t.min)/te)*u(W,U)[ie]:0))/u(i.bottom-i.top,i.right-i.left)*te+t.min;return s<t.min?t.min:s>t.max?t.max:s},R=(e,t)=>!e.target.classList.contains(t),z=(e,a=!0)=>{let i=!1;if(!t.disabled&&(R(e,"range-slider__thumb")&&R(e,"range-slider__range")||t.rangeSlideDisabled&&R(e,"range-slider__thumb"))&&(i=!0),i&&t.thumbsDisabled[0]&&t.thumbsDisabled[1]&&(i=!1),i){const i=k(e,se),r=B(K.min-i),s=B(K.max-i);if(t.thumbsDisabled[0])i>=K.min&&(g(n(K.min,i),!0,!a),T(e,Q.max,me[Q.max],!a));else if(t.thumbsDisabled[1])i<=K.max&&(g(n(i,K.max),!0,!a),T(e,Q.min,me[Q.min],!a));else{let t=Q.max;r===s?g(n(K.min,i),!0,!a):(g(n(r<s?i:K.min,s<r?i:K.max),!0,!a),t=r<s?Q.min:Q.max),T(e,t,me[t],!a)}a&&z(e,!1)}},C=(e,t)=>{$(),s(t,X),re=k(e,t),ne=!0},T=(e,a,n,i=!0)=>{t.disabled||t.thumbsDisabled[b(a)]||(C(e,n),ie=Q.min===a?M:F,i&&t.onThumbDragStart&&t.onThumbDragStart())},A=e=>{if(ne){const a=k(e,se),i=a-re;let r=K.min,s=K.max;const l=ie?Z.min:t.min,m=ie?Z.max:t.max;ie&&ie!==M||(r=ie?a:ee.min+i),ie&&ie!==F||(s=ie?a:ee.max+i),r>=l&&r<=m&&s>=l&&s<=m?(g({min:r,max:s}),re=a):(r>m&&ie&&(g(n(m,m)),re=a),s<l&&ie&&(g(n(l,l)),re=a),r<l&&(g(n(l,ie?K.max:K.max-K.min+l)),re=a),s>m&&(g(n(ie?K.min:K.min-K.max+m,m)),re=a)),ie||v()}},I=()=>{ne&&(l(me[0],X),l(me[1],X),l(se,X),ne=!1,ie?t.onThumbDragEnd&&t.onThumbDragEnd():t.onRangeDragEnd&&t.onRangeDragEnd())},L=()=>{$(),x(),f()},j=()=>{const e=q(le[0].step);return le[0].step===G?G:0===e||isNaN(e)?1:e},B=Math.abs,q=parseFloat,N=window.getComputedStyle,M="min",F="max",G="any",H="vertical",O="tabindex",P="data-lower",V="data-upper",X="data-active",Y="data-vertical",J="data-disabled",K=n(),Q=n(0,1),U=n(),W=n(),Z=n();let ee=n(),te=0,ae=0,ne=!1,ie=!1,re=0;if(!this.cssInjected){const e=document.createElement("style");e.textContent=".range-slider{touch-action:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none;cursor:pointer;display:block;position:relative;width:100%;height:8px;background:#ddd;border-radius:4px}.range-slider[data-vertical]{height:100%;width:8px}.range-slider[data-disabled]{opacity:.5;cursor:not-allowed}.range-slider .range-slider__thumb{position:absolute;z-index:3;top:50%;width:24px;height:24px;transform:translate(-50%,-50%);border-radius:50%;background:#2196f3}.range-slider .range-slider__thumb:focus-visible{outline:0;box-shadow:0 0 0 6px rgba(33,150,243,.5)}.range-slider[data-vertical] .range-slider__thumb{left:50%}.range-slider .range-slider__thumb[data-disabled]{z-index:2}.range-slider .range-slider__range{position:absolute;z-index:1;transform:translate(0,-50%);top:50%;width:100%;height:100%;background:#51adf6}.range-slider[data-vertical] .range-slider__range{left:50%;transform:translate(-50%,0)}.range-slider input[type=range]{-webkit-appearance:none;pointer-events:none;position:absolute;z-index:2;top:0;left:0;width:0;height:0;background-color:transparent}.range-slider input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none}.range-slider input[type=range]::-moz-range-thumb{width:0;height:0;border:0}.range-slider input[type=range]:focus{outline:0}";const t=document.head,a=document.querySelector("head>style,head>link");a?t.insertBefore(e,a):t.appendChild(e),this.cssInjected=!0}o("rangeSlideDisabled",!1),o("thumbsDisabled",[!1,!1]),o("orientation","horizontal"),o("disabled",!1),o("onThumbDragStart",!1),o("onRangeDragStart",!1),o("onThumbDragEnd",!1),o("onRangeDragEnd",!1),o("onInput",!1),o("value",[25,75]),o("step",1),o("min",0),o("max",100),h(),p(),e.innerHTML=`<input type="range" min="${t.min}" max="${t.max}" step="${t.step}" value="${t.value[0]}" disabled><input type="range" min="${t.min}" max="${t.max}" step="${t.step}" value="${t.value[1]}" disabled><div role="slider" class="range-slider__thumb" ${P}></div><div role="slider" class="range-slider__thumb" ${V}></div><div class="range-slider__range"></div>`,e.classList.add("range-slider");const se=e.querySelector(".range-slider__range"),le=e.querySelectorAll("input"),me=e.querySelectorAll(".range-slider__thumb");return te=t.max-t.min,g("",!0,!1),v(),y(),_(),D(),E(),m(e,"pointerdown",(e=>{z(e)})),Array.from(me).forEach(((e,a)=>{m(e,"pointerdown",(t=>{T(t,a,e)})),m(e,"keydown",(e=>{e.which>=37&&e.which<=40&&(e.preventDefault(),((e,a)=>{const n=(37===a||40===a?-1:1)*u(-1,1);if(!t.disabled&&!t.thumbsDisabled[b(e)]){let t=j();t=t===G?1:t;let a=K.min+t*(Q.min===e?n:0),i=K.max+t*(Q.max===e?n:0);a>Z.max&&(a=Z.max),i<Z.min&&(i=Z.min),g({min:a,max:i},!0)}})(a,e.which))}))})),m(se,"pointerdown",(e=>{(e=>{t.disabled||t.rangeSlideDisabled||(C(e,se),ae=K.max-K.min,ie=!1,t.onRangeDragStart&&t.onRangeDragStart())})(e)})),m(document,"pointermove",A),m(document,"pointerup",I),m(window,"resize",L),{min:(e=!1)=>r(!e&&0!==e,t.min,(()=>{S(M,e)})),max:(e=!1)=>r(!e&&0!==e,t.max,(()=>{S(F,e)})),step:(e=!1)=>r(!e,j(),(()=>{le[0].step=e,le[1].step=e,g("",!0,!0,!1)})),value:(e=!1)=>r(!e,[K.min,K.max],(()=>{g(n(e[0],e[1]),!0,!0,!1),v()})),orientation:(e=!1)=>r(!e,t.orientation,(()=>{t.orientation=e,E(),g("",!0,!0,!1)})),disabled:(e=!0)=>{t.disabled=!!e,y()},thumbsDisabled:(e=[!0,!0])=>{t.thumbsDisabled=e,p(),v(),D(),_()},rangeSlideDisabled:(e=!0)=>{t.rangeSlideDisabled=!!e},currentValueIndex:()=>ie?ie===M?0:1:-1,removeGlobalEventListeners:()=>{d(document,"pointermove",A),d(document,"pointerup",I),d(window,"resize",L)}}}}},t={},function a(n){var i=t[n];if(void 0!==i)return i.exports;var r=t[n]={exports:{}};return e[n].call(r.exports,r,r.exports,a),r.exports}(265);var e,t}));

// --- Price display helpers ---------------------------------------------------
// Show grouped thousands (e.g. 4204 -> "4,204") for DISPLAY only. Every numeric
// read strips the separators back out so the slider / filter URL stay clean.
function _stripPriceCommas(v) { return String(v == null ? '' : v).replace(/,/g, ''); }
function _groupThousands(v) {
  var parts = _stripPriceCommas(v).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}
// -----------------------------------------------------------------------------

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    let formattedSearchParams = searchParams;

    // Strip any thousands separators left by display formatting, so the price
    // filter URL and the parseInt math below always get clean numbers.
    {
      const _sp = new URLSearchParams(formattedSearchParams);
      let _spChanged = false;
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => {
        if (_sp.has(k)) { _sp.set(k, (_sp.get(k) || '').replace(/[^\d.]/g, '')); _spChanged = true; }
      });
      if (_spChanged) formattedSearchParams = _sp.toString();
    }

    if (KROWN.customer.isB2B !== 'true') {
      const urlSearchParams = new URLSearchParams(formattedSearchParams);
      const minPrice = urlSearchParams.get('filter.v.price.gte');
      const maxPrice = urlSearchParams.get('filter.v.price.lte');

      if (minPrice) {
        // Store as a class variable so applyDisplayPriceFilter always reads the current
        // value even when the section is served from cache (updateURLHash hasn't run yet).
        FacetFiltersForm.pendingDisplayMin = minPrice;
        urlSearchParams.set('display_price_min', minPrice);
        urlSearchParams.set('filter.v.price.gte', parseInt(minPrice / 1.23));
      } else {
        FacetFiltersForm.pendingDisplayMin = null;
        urlSearchParams.delete('display_price_min');
      }
      if (maxPrice) {
        FacetFiltersForm.pendingDisplayMax = maxPrice;
        urlSearchParams.set('display_price_max', maxPrice);
        urlSearchParams.set('filter.v.price.lte', parseInt(maxPrice) + 1);
      } else {
        FacetFiltersForm.pendingDisplayMax = null;
        urlSearchParams.delete('display_price_max');
      }
      formattedSearchParams = urlSearchParams.toString();
    }
    FacetFiltersForm.searchParamsPrev = formattedSearchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById('main-collection-product-grid').classList.add('loading');
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${formattedSearchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(formattedSearchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGrid(html);
        FacetFiltersForm.renderProductCount(html);
        // Must run AFTER renderProductCount so the count update isn't overwritten
        FacetFiltersForm.applyDisplayPriceFilter();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGrid(html);
    FacetFiltersForm.renderProductCount(html);
    // Must run AFTER renderProductCount so the count update isn't overwritten
    FacetFiltersForm.applyDisplayPriceFilter();
  }

  static renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML;
    document.getElementById('CollectionProductGrid').innerHTML = innerHTML;
    document.getElementById('CollectionProductGrid').querySelectorAll('template').forEach(elm=>{
      elm.closest('form')?.append(elm.content.cloneNode(true));
    });
    // NOTE: applyDisplayPriceFilter is intentionally NOT called here —
    // it is called after renderProductCount in each render path so the
    // server count is set first before our client-side count override.
  }

  /**
   * Client-side price filter — hides products whose DISPLAY price (inc. VAT)
   * falls outside the range the customer selected in the price filter.
   *
   * Why this is needed: Shopify's filter API works on admin (ex-VAT) prices.
   * Products have different VAT rates (0% or 23%), so a single server-side
   * conversion cannot correctly filter all products. Instead:
   *   - GTE is sent as display_min / 1.23  (wide lower bound)
   *   - LTE is sent as display_max          (keeps VAT=0% products in range)
   * This function then hides any cards whose data-display-price is outside
   * the original display range the customer intended.
   */
  static applyDisplayPriceFilter() {
    if (KROWN.customer.isB2B === 'true') return;

    const urlParams = new URLSearchParams(window.location.search);
    const adminGteStr = urlParams.get('filter.v.price.gte');
    const adminLteStr = urlParams.get('filter.v.price.lte');

    // Ensure the "no products" message element exists inside the product grid
    const grid = document.getElementById('CollectionProductGrid');
    let noProductsMsg = grid ? grid.querySelector('[data-js-client-no-products]') : null;
    if (grid && !noProductsMsg) {
      noProductsMsg = document.createElement('p');
      noProductsMsg.setAttribute('data-js-client-no-products', '');
      noProductsMsg.className = 'no-content-message rte';
      noProductsMsg.style.display = 'none';
      noProductsMsg.innerHTML =
        'No products found.<br>' +
        'Use fewer filters or <a href="' + window.location.pathname + '" class="button--text">clear all</a>';
      grid.appendChild(noProductsMsg);
    }

    // Helper: format a price in cents to the store's display format (€X,XXX.XX)
    // Comma thousands + dot decimals, 2 decimals always (matches the rest of the store).
    const formatMoneyCents = (cents) => {
      const [int, dec] = (cents / 100).toFixed(2).split('.');
      const thousands = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '€' + thousands + '.' + dec;
    };

    // Helper: restore a card's overridden price text and image to originals
    const restoreCard = (item) => {
      const priceEl = item.querySelector('[data-js-product-price-original]');
      if (priceEl && item.dataset.origPriceText) {
        priceEl.textContent = item.dataset.origPriceText;
        delete item.dataset.origPriceText;
      }
      if (item.dataset.origImgSrc) {
        const fig = item.querySelector('.product-item__image-figure--primary');
        const img = fig ? fig.querySelector('img') : null;
        if (img) {
          img.setAttribute('src', item.dataset.origImgSrc);
          img.setAttribute('srcset', item.dataset.origImgSrcset || '');
        }
        delete item.dataset.origImgSrc;
        delete item.dataset.origImgSrcset;
      }
    };

    if (!adminGteStr && !adminLteStr) {
      // No price filter active — restore all cards and original prices/images/count
      document.querySelectorAll('[data-display-price-min]').forEach(item => {
        item.style.display = '';
        restoreCard(item);
      });
      document.querySelectorAll('#CollectionProductCount').forEach(el => {
        if (el.dataset.origCountText) {
          el.textContent = el.dataset.origCountText;
          delete el.dataset.origCountText;
        }
      });
      if (noProductsMsg) noProductsMsg.style.display = 'none';
      return;
    }

    // Recover the customer's intended display price range (in cents).
    // Prefer the display_price_min/max params stored by renderPage (exact values the
    // user typed). Fall back to back-calculating from the admin price if those params
    // are absent (e.g. old bookmarked URLs that predate this fix).
    const adminGte = parseFloat(adminGteStr) || 0;
    const adminLte = parseFloat(adminLteStr) || Infinity;

    // Class variables are set synchronously in renderPage before any section render,
    // so they are always current even when the section comes from cache (before updateURLHash).
    // URL params are the fallback for page reload (class vars are undefined then).
    const displayMinParam = (FacetFiltersForm.pendingDisplayMin != null)
      ? FacetFiltersForm.pendingDisplayMin
      : urlParams.get('display_price_min');
    const displayMaxParam = (FacetFiltersForm.pendingDisplayMax != null)
      ? FacetFiltersForm.pendingDisplayMax
      : urlParams.get('display_price_max');

    // display_price_min/max are in major units (euros); convert to cents.
    const displayMinCents = displayMinParam
      ? Math.round(parseFloat(displayMinParam) * 100)
      : Math.round(adminGte * 123); // fallback: GTE * 1.23 (may be up to ~0.23 too low)
    const displayMaxCents = displayMaxParam
      ? Math.round(parseFloat(displayMaxParam) * 100)
      : (adminLte === Infinity ? Infinity : Math.round(adminLte * 100)); // fallback: LTE as-is

    let visibleCount = 0;
    document.querySelectorAll('[data-display-price-min]').forEach(item => {
      const productPriceMin = parseInt(item.dataset.displayPriceMin, 10);
      const productPriceMax = parseInt(item.dataset.displayPriceMax, 10);
      // Show the product if ANY of its variants' prices overlap with the filter range.
      // Overlap condition: product max >= filter min AND product min <= filter max
      const inRange = productPriceMax >= displayMinCents && productPriceMin <= displayMaxCents;
      item.style.display = inRange ? '' : 'none';
      if (inRange) visibleCount++;

      // If the card is shown but its cheapest variant is BELOW the filter minimum,
      // update both the price display and the card image to the cheapest in-range variant.
      const priceEl = item.querySelector('[data-js-product-price-original]');
      if (priceEl) {
        if (inRange && productPriceMin < displayMinCents) {
          const variantPrices = (item.dataset.variantPrices || '')
            .split(',').map(Number).filter(p => !isNaN(p) && p > 0);
          const inRangePrices = variantPrices.filter(p => p >= displayMinCents && p <= displayMaxCents);
          if (inRangePrices.length > 0) {
            const cheapestInRange = Math.min(...inRangePrices);

            // --- Update price text ---
            if (!item.dataset.origPriceText) {
              item.dataset.origPriceText = priceEl.textContent;
            }
            const hadFromPrefix = priceEl.textContent.trim().indexOf('From ') === 0;
            priceEl.textContent = hadFromPrefix
              ? 'From ' + formatMoneyCents(cheapestInRange)
              : formatMoneyCents(cheapestInRange);

            // --- Update product card image to the in-range variant's image ---
            const variantImages = (item.dataset.variantImages || '').split('|');
            const cheapestIdx = variantPrices.indexOf(cheapestInRange);
            const newImgUrl = cheapestIdx >= 0 ? variantImages[cheapestIdx] : '';
            if (newImgUrl) {
              const primaryFig = item.querySelector('.product-item__image-figure--primary');
              const img = primaryFig ? primaryFig.querySelector('img') : null;
              if (img) {
                if (!item.dataset.origImgSrc) {
                  item.dataset.origImgSrc = img.getAttribute('src') || '';
                  item.dataset.origImgSrcset = img.getAttribute('srcset') || '';
                }
                img.setAttribute('src', newImgUrl);
                img.setAttribute('srcset', newImgUrl + ' 840w');
                primaryFig.classList.add('lazyloaded');
              }
            }
          }
        } else if (item.dataset.origPriceText) {
          // Filter widened to include this variant's min price — restore originals
          restoreCard(item);
        }
      }
    });

    // Show "no products" message when client-side filtering hides everything
    if (noProductsMsg) {
      noProductsMsg.style.display = visibleCount === 0 ? '' : 'none';
    }

    // Update the product count element(s) to reflect the client-side filtered count.
    // The server renders e.g. "12 of 37 products" — we replace the leading number with
    // visibleCount so it reads "5 of 37 products" (accurate after JS filtering).
    document.querySelectorAll('#CollectionProductCount').forEach(el => {
      if (!el.dataset.origCountText) {
        el.dataset.origCountText = el.textContent.trim();
      }
      el.textContent = el.dataset.origCountText.replace(/^\d+/, String(visibleCount));
    });
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount');
    if ( countEl ) {
      document.querySelectorAll('#CollectionProductCount').forEach(elm=>{
        elm.innerHTML = countEl.innerHTML;
        // Clear any stale saved count so applyDisplayPriceFilter saves a fresh value
        delete elm.dataset.origCountText;
      });
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');



    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? ( element.dataset.index === jsFilter.dataset.index && ! element.hasAttribute('data-and-operator') ) : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    // The server re-renders price inputs with admin prices (GTE/1.23, LTE+1).
    // Restore them to the original display values so the next form submission
    // (e.g. a sort change) doesn't apply the VAT conversion a second time.
    // syncPriceBadge is called again after restoration so the badge reflects
    // the correct display values, not the server's +1 inflated LTE.
    if (KROWN.customer.isB2B !== 'true') {
      const urlParams = new URLSearchParams(window.location.search);
      const displayMin = urlParams.get('display_price_min');
      const displayMax = urlParams.get('display_price_max');
      if (displayMin || displayMax) {
        document.querySelectorAll('price-range').forEach(function(priceRange) {
          const inputMin = priceRange.querySelector('input[name="filter.v.price.gte"]');
          const inputMax = priceRange.querySelector('input[name="filter.v.price.lte"]');
          if (inputMin && displayMin) {
            inputMin.value = _groupThousands(displayMin);
            if (inputMax) inputMax.setAttribute('min', _stripPriceCommas(displayMin));
          }
          if (inputMax && displayMax) {
            inputMax.value = _groupThousands(displayMax);
            if (inputMin) inputMin.setAttribute('max', _stripPriceCommas(displayMax));
          }
        });
        FacetFiltersForm.syncPriceBadge();
      }
    }

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      if ( document.querySelector(selector) ) {
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      }
    })

    FacetFiltersForm.toggleActiveFacets(false);
    FacetFiltersForm.syncPriceBadge();
  }

  // After the badge is re-rendered from the server it may be off-by-1 due to the
  // VAT round-trip (min) and the deliberate +1 added to max before storing in the URL.
  // Read the actual input values (which are never re-rendered after slider interaction)
  // and push them into the badge text so both always show the same numbers.
  static syncPriceBadge() {
    const inputMin = document.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = document.querySelector('input[name="filter.v.price.lte"]');
    if (!inputMin || !inputMax) return;
    const minVal = inputMin.value;
    const maxVal = inputMax.value;
    if (!minVal && !maxVal) return;

    document.querySelectorAll('[data-js-price-badge-text]').forEach(function (span) {
      var badge = span.closest('[data-js-price-badge]');
      var sym = badge ? badge.dataset.jsPriceBadge : '';
      // _groupThousands strips any existing commas first, so this is safe whether
      // the input currently shows "4204" or "4,204".
      var minText = minVal ? sym + _groupThousands(minVal) : (sym + '0');
      var maxText = maxVal ? sym + _groupThousands(maxVal) : '';
      span.textContent = minText + '-' + maxText;
    });
  }

  static renderCounts(source, target) {
    const countElementSelectors = ['.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);
      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }


  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }
  
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }


  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.pendingDisplayMin = undefined;
FacetFiltersForm.pendingDisplayMax = undefined;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {

  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => {
        element.addEventListener('change', this.onRangeChange.bind(this));
        element.addEventListener('input', this.maxCheck.bind(this));
        // Display: grouped thousands when idle, plain while the user edits.
        element.addEventListener('focus', () => { element.value = _stripPriceCommas(element.value); });
        element.addEventListener('blur', () => { if (element.value) element.value = _groupThousands(element.value); });
        if (element.value) element.value = _groupThousands(element.value);
        if (element.placeholder) element.placeholder = _groupThousands(element.placeholder);
      });

    this.setMinAndMaxValues();
    
    //const usesComma = Boolean(this.getAttribute('data-uses-comma'));
    const inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = this.querySelector('input[name="filter.v.price.lte"]');
    let inputTimer = null;

    if ( this.parentElement.querySelector('[data-js-price-range-slider]') ) {
      setTimeout(()=>{
        const rangeSliderElm = this.parentElement.querySelector('[data-js-price-range-slider]');
        rangeSlider(rangeSliderElm, {
          min: Number(_stripPriceCommas(inputMin.getAttribute('min'))),
          max: Number(_stripPriceCommas(inputMax.getAttribute('max'))),
          value: [Number(_stripPriceCommas(inputMin.value)) || Number(_stripPriceCommas(inputMin.getAttribute('placeholder'))), Number(_stripPriceCommas(inputMax.value)) || Number(_stripPriceCommas(inputMax.getAttribute('placeholder')))],
          onInput: values => {
            inputMin.value = `${values[0]}`;
            inputMax.value = `${values[1]}`;
            clearTimeout(inputTimer);
            inputTimer = setTimeout(()=>{
              document.querySelector(`facet-filters-form[data-location="${rangeSliderElm.id.includes('desktop') ? 'desktop' : 'mobile'}"]`).onSubmitHandler({
                target: inputMin,
                preventDefault: ()=>{return;}
              });
              document.querySelector(`facet-filters-form[data-location="${rangeSliderElm.id.includes('desktop') ? 'desktop' : 'mobile'}"]`).onSubmitHandler({
                target: inputMax,
                preventDefault: ()=>{return;}
              });
              this.onRangeChange({
                currentTarget: inputMin
              });
              this.onRangeChange({
                currentTarget: inputMax
              });
              // Re-apply grouped display after a slider drag (slider writes raw values).
              if (document.activeElement !== inputMin && inputMin.value) inputMin.value = _groupThousands(inputMin.value);
              if (document.activeElement !== inputMax && inputMax.value) inputMax.value = _groupThousands(inputMax.value);
            }, 500);
          }
        }); 
      }, 500);
    }

  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', _stripPriceCommas(maxInput.value));
    if (minInput.value) maxInput.setAttribute('min', _stripPriceCommas(minInput.value));
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(_stripPriceCommas(input.value));
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  maxCheck(object) {
    let max = parseInt(object.target.max);
    let value = parseInt(_stripPriceCommas(object.target.value));

    if (value > max) {
      object.target.value = max
    }
  } 
}

customElements.define('price-range', PriceRange);

// On initial page load: restore display price inputs and sync the badge, then filter.
// Liquid renders the inputs with admin prices (GTE / 1.23), not the display prices
// the user saw. display_price_min/max in the URL hold the original display values.
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const displayMin = urlParams.get('display_price_min');
  const displayMax = urlParams.get('display_price_max');

  if (displayMin || displayMax) {
    document.querySelectorAll('price-range').forEach(function (priceRange) {
      var inputMin = priceRange.querySelector('input[name="filter.v.price.gte"]');
      var inputMax = priceRange.querySelector('input[name="filter.v.price.lte"]');
      if (inputMin && displayMin) {
        inputMin.value = displayMin;
        if (inputMax) inputMax.setAttribute('min', displayMin);
      }
      if (inputMax && displayMax) {
        inputMax.value = displayMax;
        if (inputMin) inputMin.setAttribute('max', displayMax);
      }
    });
  }

  FacetFiltersForm.applyDisplayPriceFilter();
  FacetFiltersForm.syncPriceBadge();
});